import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const VisionPage = lazy(() => import('../pages/vision/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const UseCasePage = lazy(() => import('../pages/usecase/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/vision',
    element: <VisionPage />
  },
  {
    path: '/business',
    element: <BusinessPage />
  },
  {
    path: '/technology',
    element: <TechnologyPage />
  },
  {
    path: '/usecase',
    element: <UseCasePage />
  },
  {
    path: '/company',
    element: <CompanyPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
